<template>
  <div></div>
</template>

<script>
import JwtManager from "@/imports/jwt-manager.js";
import resolveSafeRedirect from "@/imports/safe-redirect";

export default {
  data() {
    return {
      redirect: null,
    };
  },

  mounted() {
    this.redirect = this.$route.query.redirect;

    if (!this.$auth.check()) {
      if (!this.doExternalRedirect()) {
        this.$router.push("/login");
      }

      return;
    }

    this.reset();
    this.logout();
  },

  methods: {
    reset() {
      JwtManager.clearCookie();
      this.$ability.update([]);
      document.body.classList.remove("sidebar-lg-show");
    },

    logout() {
      this.$auth
        .logout({
          makeRequest: true,
          redirect: null,
        })
        .then(
          () => {
            if (!this.doExternalRedirect()) {
              this.$router.push("/login");
            }
          },
          () => {
            window.toastr.error("Logout failed!");
          }
        );
    },

    doExternalRedirect() {
      const target = resolveSafeRedirect(this.redirect);
      if (target && target.origin !== window.location.origin) {
        window.location = target.href;
        return true;
      }

      return false;
    },
  },
};
</script>
